import axios from 'axios';

import url from '../../components/common/BaseURL';

const baseURL = url.baseURL;

export const productNameChange = (productName) => {
    return {
        type: 'PRODUCT_NAME_CHANGE',
        payload: productName
    };
};

export const productDescriptionChange = (productDescription) => {
    return {
        type: 'PRODUCT_DESCRIPTION_CHANGE',
        payload: productDescription
    };
};

export const productLinkChange = (productLink) => {
    return {
        type: 'PRODUCT_LINK_CHANGE',
        payload: productLink
    };
};

export const productPictureLinkChange = (productPictureLink) => {
    return {
        type: 'PRODUCT_PICTURE_LINK_CHANGE',
        payload: productPictureLink
    };
};

export const productMessageChange = (productMessage) => {
    return {
        type: 'PRODUCT_MESSAGE_CHANGE',
        payload: productMessage
    };
};



// WEBPACK FOOTER //
// ./src/actions/Products/ProductAction.js